import React, { Component } from "react";
import { Link } from "react-router-dom";
import Constant from "../../Constant";
import ImageUploader from "react-images-upload";
import ImagesUploader from "react-images-uploader";

export default class UpdateUserType extends Component {
  state = {
    categories: [],
  };
  componentDidMount() {
    this.getRules();
    this.getUserType();
  }
  getUserType = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("roleId", this.props.match.params.user_type_id);
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/role/getUsers", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        var data = result.data;
        this.setState({
          name: data.name,
          discription: data.description,
        });
        this.setState({ course: data, loading: false });
      })
      .catch((error) => console.log("error", error));
  };
  getRules = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/role/getRules", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        var data = result.data;
        for (let i = 0; i < data.length; i++) {
          console.log(data[i]);
          var str = data[i].createdAt;
          var date = new Date(str);
          data[i].createdAt = `${date.getUTCDate()}-${
            date.getUTCMonth() + 1
          }-${date.getUTCFullYear()}`;
        }
        this.setState({ data: data, loading: false });
      })
      .catch((error) => console.log("error", error));
  };

  createUserType = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("name", this.state.name);
    urlencoded.append("rules", []);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/role/add", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        window.location.href = "#/admin/user-types/";
      })
      .catch((error) => console.log("error", error));
  };
  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
    console.log(this.state);
  };

  render() {
    return (
      <div className="py-3">
        <div className="container border shadow-sm p-0 bg-white">
          <div className="header bg-primary text-white">
            <div className="row m-0">
              <div className="col-md-6 p-3 d-flex align-items-center">
                <h5 className="m-0">
                  <Link to="/admin/dashboard">Home</Link> /{" "}
                  <Link to="/admin/user-types">User Types</Link> /{" "}
                  <b> Add User Type</b>
                </h5>
              </div>
              <div className="col-md-6 d-flex justify-content-end align-items-center">
                {/* <div className="btn btn-dark float-right">Add Course</div> */}
              </div>
            </div>
          </div>

          <div className="row m-0 mt-3">
            <div className="col-md-6">
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Name
                </label>
                <input
                  type="text"
                  class="form-control col-8"
                  placeholder="Name"
                  id="inputDefault"
                  name="name"
                  value={this.state.name}
                  onChange={this.onInputChange}
                />
              </div>
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Permissions
                </label>
                <div class="col-8">
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="customCheck2"
                      disabled=""
                    />
                    <label class="custom-control-label" for="customCheck2">
                      Administrator
                    </label>
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="customCheck2"
                      disabled=""
                    />
                    <label class="custom-control-label" for="customCheck2">
                      Trainer
                    </label>
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="customCheck2"
                      disabled=""
                    />
                    <label class="custom-control-label" for="customCheck2">
                      Learner
                    </label>
                  </div>
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="customCheck2"
                      disabled=""
                    />
                    <label class="custom-control-label" for="customCheck2">
                      General
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="p-3 m-0 border-top">
            <div className="btn btn-primary" onClick={this.createUserType}>
              {" "}
              Save
            </div>{" "}
            or <Link to="/admin/user-types" className="btn-link">Cancel</Link>
          </div>
        </div>
      </div>
    );
  }
}
